const translations = {
	page_title: "Vos clients",
	table: {
		columns: {
			civility: "Civilité",
			last_name: "Nom",
			first_name: "Prénom",
			subscription_sum: "Montant total des souscriptions",
			last_subscription_date: "Date de la dernière souscription",
			number_of_subscriptions: "Nombre de produits souscrits",
		},
	},
};

export default translations;
